import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import StickyBox from 'react-sticky-box';
import ReactRouterPropTypes from 'react-router-prop-types';

import InputContainer from '~COMPONENTS/formInputs/containers/InputContainer';
import Button from '~COMPONENTS/button/Button';
import NoResults from '../../components/NoResults';
import LoadingMessage from '~COMPONENTS/spinner/LoadingMessage';
import TextInput from '~COMPONENTS/formInputs/TextInput';
import PageHeader from '~COMPONENTS/containers/PageHeader';
import OrderDetailsProduct from './OrderDetailsProduct';
import OrderDetailsHeader from './OrderDetailsHeader';
/* eslint-disable import/no-cycle */
import OrderDetailsSummary from './OrderDetailsSummary';
import OrderDetailsShipments from './shipmentView/OrderDetailsShipments';
import { DownloadBanner } from '../../components/DownloadBanner';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { DownloadModal, DownloadModalCancelOverlay } from '../../downloads';
import OrderDetailsPF from '../../print/orderDetails/OrderDetailsPF';

import { generateReport, setStatus } from '../../downloads/actions';
import { options } from '../../downloads/reducer';
import {
  requestOrderDetails,
  clearOrderDetails,
  addOrderShippingAddress,
  generateOrderTrackingReport,
  clearDownloadReportError
} from '../actions';
import { orderDetailsData, isGeneratingOrderTrackingReport, hasDownloadError } from '../reducer';
import { getUserAccount, selectDepartments } from '../../user/selectors';

import {
  getIsShoppingEnabled,
  getCountryProvinces,
  getIsGreaterChinaSalesOrg,
  getIsEUSalesOrg,
  getIsUSSalesOrg,
  getIsAustraliaSalesOrg,
  getIsJapanSalesOrg
} from '../../gamedayAccount/selectors';
import { requestSubmittedReturns, setSelectedReturnId } from '../orderReturns/actions';
import { getOrderReturnDetails, isFetching, submittedReturns } from '../orderReturns/reducer';
import { setSilentSearchTerm } from '../../global/actions';
import { openModal, closeModal, disableModal, enableModal } from '../../components/modal/actions';

import { filterListNested } from '../../util/filterListNested';
import getReturnableProductQuantities from '../../util/getReturnableProductQuantities';

import { STATUS_SHIPPED, STATUS_PARTIALLY_SHIPPED, STATUS_CANCELLED } from '../orderReturns/constants';
import { ORDER_TYPE_ATONCE, ORDER_TYPE_ATONCE_ALT, ORDER_TYPE_FUTURES } from '../../shop/constants';
import { ORDERTYPE_TYPE_MAP, endpointSuccess } from '../constants';
import { STATUS_IDLE, REPORT_TYPE_ORDER } from '../../downloads/constants';

import { userAccountTypes, departmentsTypes } from '../../types/user';
import { CART_TYPES } from '../../carts/constants';

export class OrderDetails extends Component {
  constructor(props) {
    super(props);
    const {
      match,
      match: {
        path,
        params: { orderId }
      }
    } = this.props;
    this.state = {
      id: orderId,
      expandAll: false,
      searchTerm: '',
      displayProducts: null,
      loadError: false,
      shipmentsView: match && path ? path.split('/').pop() === 'shipments' : false,
      showDownloadBanner: false
    };
  }

  async componentDidMount() {
    document.body.classList.add('details');
    // --
    const { id } = this.state;
    const { orderDetailsData, setSilentSearchTerm, requestOrderDetails, setSelectedReturnId } = this.props;

    setSelectedReturnId('');
    setSilentSearchTerm('');
    await requestOrderDetails(id).then(({ type }) => this.setState({ loadError: !endpointSuccess(type) }));

    if (!orderDetailsData) return;
    this.initializeOrderDetails();
  }

  componentDidUpdate(prevProps) {
    const { orderDetailsData } = this.props;
    if (!prevProps.orderDetailsData && orderDetailsData) {
      this.initializeOrderDetails();
    }
  }

  componentWillUnmount() {
    const { clearOrderDetails } = this.props;
    document.body.classList.remove('details');
    clearOrderDetails();
  }

  setDisplayProducts = products => this.setState({ displayProducts: products });

  initializeOrderDetails = () => {
    const {
      orderDetailsData: { status, productDetails, shipToAddress },
      requestSubmittedReturns,
      addOrderShippingAddress
    } = this.props;

    if (status && (status === STATUS_SHIPPED || status === STATUS_PARTIALLY_SHIPPED)) {
      const { id } = this.state;
      requestSubmittedReturns(id);
    }

    if (productDetails) {
      this.setDisplayProducts(productDetails);
    }

    addOrderShippingAddress(shipToAddress);
  };

  updateList = inputValue => {
    const {
      orderDetailsData: { productDetails }
    } = this.props;

    this.setState({
      searchTerm: inputValue,
      displayProducts: filterListNested(
        Object.keys(productDetails).map(key => productDetails[key]),
        ['copy.name', 'productCode'],
        inputValue
      )
    });
  };

  toggleExpandAllSizeGrids = () => this.setState(prevState => ({ expandAll: !prevState.expandAll }));

  handleBeginReturnClick = e => {
    const {
      history,
      match: { params }
    } = this.props;
    e.preventDefault();
    history.push(`/orders/returns/id/${params.orderId}`);
  };

  isEligibleForReturn = () => {
    const {
      orderDetailsData: { status, productDetails }
    } = this.props;

    if (!status || status === '' || (status !== STATUS_SHIPPED && status !== STATUS_PARTIALLY_SHIPPED)) return false;

    const returnableProductQuantities = getReturnableProductQuantities(productDetails);

    if (!returnableProductQuantities || returnableProductQuantities === undefined) return false;

    for (let i = 0, l = returnableProductQuantities.length; i < l; i++) {
      if (returnableProductQuantities[i].returnable && returnableProductQuantities[i].totalReturnableQuantity > 0)
        return true;
    }
    return false;
  };

  handleRelatedReturnsClick = async e => {
    e.preventDefault();
    const { id } = this.state;
    const { setSilentSearchTerm, history } = this.props;
    await setSilentSearchTerm(id);
    history.push('/orders/returns');
  };

  confirmDownload = () => {
    const {
      generateReport,
      closeModal,
      disableModal,
      options,
      orderDetailsData: { departmentName }
    } = this.props;
    const { id } = this.state;
    generateReport({
      type: REPORT_TYPE_ORDER,
      data: {
        orderId: id,
        title: 'downloads.type.report.os',
        options: options,
        departmentName: departmentName
      }
    });
    closeModal();
    disableModal();
  };

  cancelDownload = () => {
    const { setStatus, enableModal } = this.props;
    setStatus(STATUS_IDLE);
    enableModal();
  };

  download = e => {
    e.preventDefault();
    const { openModal, closeModal } = this.props;
    openModal({
      type: 'alert',
      title: new TranslatedCopy({
        id: 'global.download.value',
        values: { item: new TranslatedCopy({ id: 'global.order' }).toString() }
      }).toString(),
      content: <DownloadModal type={REPORT_TYPE_ORDER} />,
      confirmText: new TranslatedCopy({ id: 'global.download' }).toString(),
      confirmAction: this.confirmDownload,
      cancelText: new TranslatedCopy({ id: 'global.button.cancel' }).toString(),
      cancelAction: closeModal,
      disabledContent: <DownloadModalCancelOverlay cancelDownload={this.cancelDownload} />
    });
  };

  downloadTrackingReport = async e => {
    e.preventDefault();
    const { generateOrderTrackingReport } = this.props;
    const { id } = this.state;
    this.setState({ showDownloadBanner: true });
    await generateOrderTrackingReport({ orderIds: [id] });
  };

  handleCloseBanner = async () => {
    const { clearDownloadReportError } = this.props;
    this.setState({ showDownloadBanner: false });
    await clearDownloadReportError();
  };

  print = e => {
    e.preventDefault();
    window.print();
  };

  viewShipmentsClick = () => {
    this.setState(prevState => ({ shipmentsView: !prevState.shipmentsView }));
  };

  render() {
    const { expandAll, searchTerm, displayProducts, shipmentsView, loadError, showDownloadBanner } = this.state;
    const {
      isFetching,
      departments,
      submittedReturns,
      account,
      orderDetailsData,
      isGreaterChinaSalesOrg,
      isUSSalesOrg,
      isEUSalesOrg,
      isAustraliaSalesOrg,
      isJapanSalesOrg,
      isShoppingEnabled,
      provinces,
      isGeneratingOrderTrackingReport,
      hasDownloadError
    } = this.props;

    if (loadError) return <NoResults titleId='orderstatus.search.order.noresults.title' />;
    if (!orderDetailsData) return <LoadingMessage title={new TranslatedCopy({ id: 'global.order' }).toString()} />;

    const {
      orderType,
      accountNumber,
      status,
      sapOrderNumber,
      paymentMethod,
      customerPO,
      orderSubmitted,
      customerRequestDate,
      submittedBy,
      orderNetTotal,
      taxTotal,
      currencyCode,
      departmentName,
      productDetails,
      retailNetTotal,
      shippingInformation,
      shipToAddress,
      totalQty,
      allotmentPeriod
    } = orderDetailsData;
    const blnViewShipments =
      shippingInformation &&
      shippingInformation.length > 0 &&
      (ORDERTYPE_TYPE_MAP[orderType] === ORDER_TYPE_ATONCE ||
        ORDERTYPE_TYPE_MAP[orderType] === ORDER_TYPE_ATONCE_ALT ||
        ORDERTYPE_TYPE_MAP[orderType] === ORDER_TYPE_FUTURES);
    const hasReturns = submittedReturns?.pages.totalResources > 0;
    const eligibleForReturn = this.isEligibleForReturn();
    const expiredContractReturn = !allotmentPeriod.isReturnable;
    const hasFutureContractReturn = allotmentPeriod.isFutureReturnable;
    const futureReturnStartDate = allotmentPeriod.startDate;
    const accountName = account
      ? account.name
      : departments.filter(({ customerNumber }) => customerNumber === accountNumber)[0].customerName;
    const isForecast = orderType === CART_TYPES.FORECAST;
    const updatedShipToAddress =
      isEUSalesOrg || isJapanSalesOrg
        ? {
            ...shipToAddress,
            provinceStateCode: {
              value: provinces[shipToAddress.provinceStateCode?.value] || shipToAddress.provinceStateCode?.value
            }
          }
        : shipToAddress;

    const renderOrderDetailsSummary = () => (
      <OrderDetailsSummary
        accountName={accountName}
        currencyCode={currencyCode}
        customerRequestDate={customerRequestDate}
        departmentName={departmentName}
        handleBeginReturnClick={this.handleBeginReturnClick}
        handleRelatedReturnsClick={this.handleRelatedReturnsClick}
        hasReturns={hasReturns}
        isEligibleForReturn={eligibleForReturn && isShoppingEnabled}
        isExpiredContractReturn={expiredContractReturn}
        hasFutureContractReturn={status !== STATUS_CANCELLED && hasFutureContractReturn}
        futureReturnStartDate={futureReturnStartDate}
        isUSSalesOrg={isUSSalesOrg}
        netRetailTotal={retailNetTotal}
        netWholeSaleTotal={orderNetTotal}
        taxTotal={taxTotal}
        orderSubmittedBy={submittedBy}
        orderSubmittedDate={orderSubmitted}
        orderType={orderType}
        paymentMethod={paymentMethod}
        poNumber={customerPO}
        shipToAddress={updatedShipToAddress}
        totalQty={totalQty}
        isForecast={isForecast}
        isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
        isAustraliaSalesOrg={isAustraliaSalesOrg}
        isJapanSalesOrg={isJapanSalesOrg}
      />
    );

    return (
      <>
        <div className='orderDetails'>
          <div className='orderDetails__mainWrap'>
            <PageHeader
              page='orderDetails'
              className='orderDetails__header ta-sm-c ta-md-l flx-ai-sm-fs'
              title={
                <OrderDetailsHeader
                  orderStatus={status}
                  orderNumber={sapOrderNumber}
                  productCount={productDetails ? Object.keys(productDetails).length : 0}
                  downloadHander={this.download}
                  downloadReportHandler={this.downloadTrackingReport}
                  printHandler={this.print}
                  showDownloadReportButton={blnViewShipments}
                />
              }
              linkBack={{
                url: '/orders/status',
                linkTitle: new TranslatedCopy({ id: 'orderstatus.orderStatus' }).toString()
              }}
            />
            <div className='d-sm-b d-lg-h mb4-sm pt2-sm bg-white'>{renderOrderDetailsSummary()}</div>
            {displayProducts && (Object.keys(displayProducts).length > 0 || searchTerm) && (
              <>
                <div className='orderDetails__viewShipments d-sm-b d-md-h p2-sm prl6-sm'>
                  {blnViewShipments && (
                    <Button
                      extraClassName='bg-white u-full-width'
                      data-desc='orderDetails__viewShipments_button'
                      onClick={this.viewShipmentsClick}
                      secondary
                    >
                      {shipmentsView ? (
                        <TranslatedCopy id='orderstatus.viewbyproducts' />
                      ) : (
                        <TranslatedCopy id='orderstatus.viewbyshipments' />
                      )}
                    </Button>
                  )}
                </div>
                <div
                  className={classnames(
                    'orderDetails__search bg-primary-grey z1',
                    'pt1-sm pl8-sm pl3-md pr4-md pl8-lg pr12-lg',
                    'flex-container row space-between align-center'
                  )}
                >
                  <InputContainer
                    label={<TranslatedCopy id='orderstatus.orderDetails.search' />}
                    isSearch
                    extraClassName='search-input'
                  >
                    <TextInput
                      type='text'
                      autoComplete='off'
                      name='orderDetails__search'
                      onChange={this.updateList}
                      value={searchTerm}
                    />
                  </InputContainer>
                  <div className='d-sm-h d-md-ib'>
                    {blnViewShipments && (
                      <Button
                        extraClassName='mr2-sm pb2-sm'
                        data-desc='viewShipments_button'
                        onClick={this.viewShipmentsClick}
                        secondary
                      >
                        {shipmentsView ? (
                          <TranslatedCopy id='orderstatus.viewbyproducts' />
                        ) : (
                          <TranslatedCopy id='orderstatus.viewbyshipments' />
                        )}
                      </Button>
                    )}
                    <Button
                      secondary
                      onClick={this.toggleExpandAllSizeGrids}
                      extraClassName={classnames('expand', {
                        collapse: expandAll
                      })}
                    >
                      {expandAll ? (
                        <TranslatedCopy id='orderstatus.collapseall' />
                      ) : (
                        <TranslatedCopy id='orderstatus.expandall' />
                      )}
                    </Button>
                  </div>
                </div>
              </>
            )}
            <div className='orderDetails__main prl2-sm pr4-md prl12-lg pt1-sm pb4-sm bg-primary-grey u-full-width'>
              <div className='orderDetails__inner'>
                {shipmentsView ? (
                  <OrderDetailsShipments expandAll={expandAll} orderDetailsData={orderDetailsData} />
                ) : (
                  <>
                    {!displayProducts || isFetching ? (
                      <LoadingMessage title={new TranslatedCopy({ id: 'global.products' }).toString()} />
                    ) : (
                      <>
                        {displayProducts && Object.keys(displayProducts).length > 0 ? (
                          Object.keys(displayProducts).map(key => (
                            <OrderDetailsProduct
                              key={`orderDetails__${displayProducts[key].productCode}`}
                              product={displayProducts[key]}
                              expandAll={expandAll}
                              currencyCode={currencyCode}
                              isForecast={isForecast}
                              isGreaterChinaSalesOrg={isGreaterChinaSalesOrg}
                            />
                          ))
                        ) : (
                          <NoResults titleId='orderreturns.noProducts' />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className='d-sm-h d-lg-b'>
            <StickyBox offsetTop={128} offsetBottom={0} style={{ height: '100%' }}>
              {renderOrderDetailsSummary()}
            </StickyBox>
          </div>
        </div>
        <OrderDetailsPF shipmentsView={shipmentsView} />
        {showDownloadBanner && (
          <DownloadBanner
            title={new TranslatedCopy({ id: 'orderstatus.orderTrackingReport' }).toString()}
            isLoading={isGeneratingOrderTrackingReport}
            hasError={hasDownloadError}
            closeBanner={this.handleCloseBanner}
          />
        )}
      </>
    );
  }
}

OrderDetails.propTypes = {
  account: userAccountTypes.isRequired,
  closeModal: PropTypes.func.isRequired,
  addOrderShippingAddress: PropTypes.func.isRequired,
  departments: departmentsTypes,
  history: PropTypes.any.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  isUSSalesOrg: PropTypes.bool.isRequired,
  isEUSalesOrg: PropTypes.bool.isRequired,
  isAustraliaSalesOrg: PropTypes.bool.isRequired,
  isJapanSalesOrg: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  disableModal: PropTypes.func.isRequired,
  enableModal: PropTypes.func.isRequired,
  isShoppingEnabled: PropTypes.bool.isRequired,
  orderDetailsData: PropTypes.object,
  requestOrderDetails: PropTypes.func.isRequired,
  requestSubmittedReturns: PropTypes.func.isRequired,
  setSilentSearchTerm: PropTypes.func.isRequired,
  submittedReturns: PropTypes.object,
  generateReport: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
  match: ReactRouterPropTypes.match,
  options: PropTypes.array,
  setSelectedReturnId: PropTypes.func.isRequired,
  clearOrderDetails: PropTypes.func.isRequired,
  provinces: PropTypes.object.isRequired,
  generateOrderTrackingReport: PropTypes.func.isRequired,
  clearDownloadReportError: PropTypes.func.isRequired,
  isGeneratingOrderTrackingReport: PropTypes.bool.isRequired,
  hasDownloadError: PropTypes.bool.isRequired
};

OrderDetails.defaultProps = {
  departments: null,
  orderDetailsData: null,
  submittedReturns: null,
  match: null,
  options: null
};

const mapStateToProps = state => ({
  orderDetailsData: orderDetailsData(state),
  submittedReturns: submittedReturns(state),
  isFetching: isFetching(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state),
  isUSSalesOrg: getIsUSSalesOrg(state),
  isEUSalesOrg: getIsEUSalesOrg(state),
  isAustraliaSalesOrg: getIsAustraliaSalesOrg(state),
  isJapanSalesOrg: getIsJapanSalesOrg(state),
  orderReturnDetails: getOrderReturnDetails(state),
  departments: selectDepartments(state),
  account: getUserAccount(state),
  options: options(state),
  isShoppingEnabled: getIsShoppingEnabled(state),
  provinces: getCountryProvinces(state),
  isGeneratingOrderTrackingReport: isGeneratingOrderTrackingReport(state),
  hasDownloadError: hasDownloadError(state)
});

const connector = connect(mapStateToProps, {
  requestOrderDetails,
  requestSubmittedReturns,
  setSilentSearchTerm,
  openModal,
  closeModal,
  disableModal,
  enableModal,
  generateReport,
  setStatus,
  setSelectedReturnId,
  clearOrderDetails,
  addOrderShippingAddress,
  generateOrderTrackingReport,
  clearDownloadReportError
});

export default connector(OrderDetails);
